<template>
  <div>
    <ul
      v-if="!hasEdit"
      class="nav nav-tabs mb-3">
      <li class="nav-item">
        <button
          type="button"
          class="nav-link"
          :class="{ active: type === 'manual' }"
          @click="type='manual'">
          Manual
        </button>
      </li>
      <li class="nav-item">
        <button
          type="button"
          class="nav-link"
          :class="{ active: type === 'auto' }"
          @click="type='auto'">
          Automático AI (Beta) <i class="fa fa-star" />
        </button>
      </li>
    </ul>

    <div v-if="type==='manual'">
      <div
        v-if="!hasEdit"
        class="mb-3">
        <SelectScoreform
          :value="value.scoreform_id"
          @inputObject="setScoreform"
          :placeholder="$t('Select a scorecard')" />
      </div>
      
      <div
        class="card mb-3"
        v-if="value.scorecard && value.scorecard.groups && value.scorecard.groups.length">
        <div
          v-for="(group, group_index) in value.scorecard.groups"
          :key="group_index">

          <div class="card-header">
            <strong>{{ group.name }}</strong>
          </div>

          <ul class="list-group list-group-flush">
            <li
              class="list-group-item"
              v-for="(question, question_index) in group.questions"
              :key="question_index">

              <div class="d-flex">
                <div class="w-100 mr-2">
                  <strong>{{ question.name }}</strong>
                </div>
                <div class="">
                  <radio-evaluation
                    size="sm"
                    v-model="question.score"></radio-evaluation>
                </div>
                <div class="">
                  <button
                    type="button"
                    class="btn btn-light btn-sm disable"
                    @click="showComment(question)"
                    :disabled="Boolean(question.comment)">
                    <i class="fas fa-align-left" />
                  </button>
                </div>
              </div>
              <ValidateMessage :error="validateErrors['scorecard.groups.' + group_index + '.questions.' + question_index + '.score']" />
              
              <div
                v-if="question.show_comment || question.comment"
                class="mt-2">
                <textarea-autosize
                  v-model="question.comment"
                  :min-height="30"
                  :max-height="350"
                  class="form-control">
                  </textarea-autosize>
                <ValidateMessage :error="validateErrors['scorecard.groups.' + group_index + '.questions.' + question_index + '.comment']" />
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="mb-2">
          <div>
            <radio-evaluation
              v-model="value.score"
              :legend="true"></radio-evaluation>
          </div>
          <ValidateMessage :error="validateErrors.score" />
        </div>
        <div class="mb-2">
          <textarea-editable v-model="value.comment"></textarea-editable>
          <ValidateMessage :error="validateErrors.comment" />
        </div>
        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary"
            @click="saveEvaluation(value)">
            {{ $t('Save') }}
          </button>
          <button
            v-if="hasEdit"
            type="button"
            class="btn btn-light"
            @click="$emit('cancel')">
            {{ $t('Cancel') }}
          </button>
        </div>
      </div>
    </div>

    <div
      style="position: relative;"
      v-if="type==='auto'">
      <vue-particles
        v-if="loading"
        style="width: 100%; height: 100%; position: absolute; z-index: 2"
        color="#000000"
        :particleOpacity="0.7"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="4"
        linesColor="#212529"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="5"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push" />
      <div :class="{'box-loading': loading}">
        <p>Agora você pode avaliar o perfil de candidatos em relação à vaga com um clique, utilizando inteligência artificial para analisar tanto o perfil quanto, se disponível, a avaliação Big5 do candidato.</p>
        <p>Importante: Este recurso está em fase beta e é gratuito por enquanto, mas será comercializado em pacotes após a fase de testes devido ao alto custo dos modelos de IA avançados. Seu feedback é muito importante para nós, então não hesite em enviar dúvidas ou sugestões.</p>
        <button
          type="button"
          class="btn btn-primary"
          @click="createAutoEvaluation()">
          {{ $t('Gerar') }}
        </button>
      </div>
    </div>

  </div>

</template>

<script>
import SelectScoreform from '@/components/Fields/SelectScoreform'
import RadioEvaluation from '@/components/Fields/RadioEvaluation'
import Formsave from '@/utils/Formsave'

export default {
  name: 'CandidateEvaluationForm',
  components: {
    SelectScoreform,
    RadioEvaluation
  },
  props: {
    initValue: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      type: 'manual',
      validateErrors: false,
      loading: false,
      value: this.defaultValues(this.initValue)
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    },
    hasEdit () {
      return this.value._id
    }
  },
  created () {
    if (!this.hasEdit) {
      Formsave.sync(this, 'CandidateEvaluation', this.candidate._id, 'value', (data) => {
        return data.scorecard || data.comment
      })
    }
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    saveEvaluation
    */
    saveEvaluation (data) {
      if (data._id) this.updateEvaluation(data)
      else this.createEvaluation(data)
    },
    /*
    resetEvaluation
    */
    resetEvaluation () {
      this.value = {}
      this.validateErrors = false
    },
    /*
    createEvaluation
    */
    createEvaluation (data) {
      this.loading = true

      data.candidate_id = this.candidate._id
      data.job_id = this.selectedJob._id

      this.$store
      .dispatch('createEvaluation', data)
      .then((result) => {
        this.loading = false
        this.resetEvaluation()
        this.$emit('created', result.data)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    createAutoEvaluation
    */
    createAutoEvaluation () {
      this.loading = true

      this.$store
      .dispatch('createAutoEvaluation', {
        candidate_id: this.candidate._id,
        job_id: this.selectedJob._id
      })
      .then((result) => {
        this.loading = false
        this.resetEvaluation()
        this.$emit('created', result.data)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateEvaluation
    */
    updateEvaluation (data) {
      this.loading = true

      this.$store
      .dispatch('updateEvaluation', data)
      .then((result) => {
        this.loading = false
        this.$emit('updated', data)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    showComment (question) {
      this.$set(question, 'show_comment', !question.show_comment)
      this.$set(question, 'comment', null)
    },
    /*
    setScoreform
    */
    setScoreform (scoreform) {
      if (scoreform) {
        const scorecard = {
          name: scoreform.name,
          groups: scoreform.groups.map(group => {
            return {
              name: group.name,
              questions: group.questions.map(question => {
                return {
                  name: question,
                  comment: null,
                  score: null
                }
              })
            }
          })
        }

        this.value = {
          ...this.value,
          scoreform_id: scoreform._id,
          scorecard: scorecard
        }
      } else {
        this.value = {
          ...this.value,
          scoreform_id: null,
          scorecard: null
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Evaluation/CandidateEvaluationForm.vue